import * as R from 'ramda'

export const accountCertificateType: {
  [key: string]: string;
} = {
  ID_CARD: 'ID Card',
  DRIVING_LICENSE: 'Driving License',
  SSN: 'SSN',
  DDC: 'DDC',
  MVR: 'MVR',
  OTHER: 'Other'
}

export const typeKeys = R.keys(accountCertificateType)
export const typeValues = R.values(accountCertificateType)
